// removed by extract-text-webpack-plugin
module.exports = {"color-input":"color-input---Skwic"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/ColorInput/style.styl
// module id = wgR7
// module chunks = 89